import { type Theme, useTheme } from '../../context/ThemeContext.js';

const OPTIONS: { value: Theme; label: string }[] = [
  { value: 'system', label: 'System' },
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
];

/**
 * 115: the 3-way replacement for the sidebar's binary `ThemeToggle` — text-labeled, no icon.
 * `ThemeToggle.tsx` itself is untouched; it stays the pre-auth corner control.
 */
export function ThemeModeSwitch() {
  const { theme, setTheme } = useTheme();

  return (
    <div
      role="radiogroup"
      aria-label="Theme"
      className="flex rounded-full border border-hairline-strong p-0.5"
    >
      {OPTIONS.map((option) => {
        const checked = theme === option.value;
        return (
          <button
            key={option.value}
            type="button"
            // biome-ignore lint/a11y/useSemanticElements: #950 a segmented control: buttons with role="radio" in a radiogroup is the ARIA pattern; native radio inputs would change the look and focus behaviour
            role="radio"
            aria-checked={checked}
            aria-label={option.label}
            onClick={() => setTheme(option.value)}
            className={[
              'flex-1 rounded-full px-3 py-1 text-sm transition-colors',
              checked ? 'bg-primary text-on-primary' : 'text-steel hover:text-ink',
            ].join(' ')}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
